import React from "react";
import { CreditAuthorizationDisclaimer } from "@/components/CreditAuthorizationDisclaimer/CreditAuthorizationDisclaimer";
import { CreditAuthorizationForm } from "@/components/CreditAuthorizationForm/CreditAuthorizationForm";
import { MultiStepItemProps } from "@ucl/library";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import "./CreditAuthorizationStep.scss";

export interface CreditAuthorizationStepProps extends MultiStepItemProps {
  creditAuthorizationId?: string;
}

export const CreditAuthorizationStep: React.FC<CreditAuthorizationStepProps> = (props) => {
  return (
    <RequireAuth clientType="consumer">
      <CreditAuthorizationStepInner {...props} />
    </RequireAuth>
  );
};

const CreditAuthorizationStepInner: React.FC<CreditAuthorizationStepProps> = ({
  creditAuthorizationId,
}) => {
  if (!creditAuthorizationId) {
    return (
      <section className="credit-authorization step-section">
        <div className="credit-authorization__header step-header">Credit Authorization & Consent</div>
        <div className="credit-authorization__content step-content">
          <div style={{ color: "#dc3545", textAlign: "center" }}>
            Credit authorization is not available for this application.
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="credit-authorization step-section">
      <div className="credit-authorization__header step-header">Credit Authorization & Consent</div>
      <div className="credit-authorization__content step-content">
        <CreditAuthorizationDisclaimer />
        <CreditAuthorizationForm 
          creditAuthorizationId={creditAuthorizationId} 
          showBrowserTabMessage={false}
        />
      </div>
    </section>
  );
};
